import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const badge = css`
  position: absolute;
  inset-block-start: ${spacing(-0.25)};
  inset-inline-end: ${spacing(-0.5)};
  box-shadow: ${spacing(0, 0.4, 0.625, 0)} #d4412e4d;
  border-radius: ${spacing(12.5)};
  padding: ${spacing(0.25, 0.75)};
`
